







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Loading extends Vue {
  
  @Prop({ default: 'Loading...',  type: String}) label!: string;
}
